import React from 'react';
import { commonStyles } from '../styles/commonStyles';

interface ToggleSwitchProps {
  checked: boolean;
}

// Shared on/off pill switch used by the coverage toggle rows (Rechtsbijstand and,
// once migrated, Inboedel/Personenauto). Base styling lives in commonStyles; only
// the dynamic on-state colour and knob position are applied here.
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked }) => (
  <div
    style={{ ...commonStyles.toggleSwitch, ...(checked ? commonStyles.toggleSwitchOn : commonStyles.toggleSwitchOff) }}
  >
    <div
      style={{ ...commonStyles.toggleSlider, ...(checked ? commonStyles.toggleSliderOn : commonStyles.toggleSliderOff) }}
    />
  </div>
);

export default ToggleSwitch;
